import { CAT_CLASSES, CAT_CLASS_IDS, type CatClassId, type CatClassDef } from '@cradle7/shared';

export { CAT_CLASSES };
export type { CatClassId, CatClassDef };

export function getCatClass(id: CatClassId): CatClassDef {
  const entry = CAT_CLASSES.find((c) => c.id === id);
  if (!entry) throw new Error(`unknown cat class: ${id}`);
  return entry;
}

export function isCatClassId(s: string): s is CatClassId {
  return (CAT_CLASS_IDS as readonly string[]).includes(s);
}
